module.exports = __webpack_public_path__ + "img/2023-05.c86291ef.jpg";